import React from 'react';
import { defineMessages } from 'react-intl';
import YieldEmptyState from './YieldEmptyState';

const messages = defineMessages({
  title: {
    id: 'yield-management.empty-insights.title',
    defaultMessage: 'Insights aren’t available for this class.',
  },
  subtitle: {
    id: 'yield-management.empty-insights.subtitle',
    defaultMessage: 'This can happen if the class was disabled or deleted.',
  },
});

const EmptyInsights = () => <YieldEmptyState title={messages.title} subtitle={messages.subtitle} />;

export default EmptyInsights;
